"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Facebook32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M13.505 9.557l.002-.095c.007-.315.01-.54.01-.943C13.629 5.184 15.554 4 18.268 4H22a.5.5 0 01.5.5v3.534a.5.5 0 01-.5.5h-1.688c-1.703 0-1.823.124-1.823 1.197v1.765h3.033a.5.5 0 01.5.5v3.033a.5.5 0 01-.5.5H18.49V25.5a.5.5 0 01-.5.5h-3.971a.5.5 0 01-.5-.5v-9.971H10.5a.5.5 0 01-.5-.5v-3.033a.5.5 0 01.5-.5h3.009c-.017-1-.016-1.444-.004-1.94zM21.5 5h-3.232c-2.242 0-3.662.873-3.75 3.535 0 .395-.004.628-.011.951l-.003.094c-.013.557-.012 1.048.013 2.407a.5.5 0 01-.5.51H11v2.032h3.018a.5.5 0 01.5.5V25h2.97v-9.971a.5.5 0 01.5-.5h3.034v-2.033H17.99a.5.5 0 01-.5-.5V9.731c0-1.618.56-2.197 2.823-2.197H21.5V5z", className: "facebook-32_svg__path-1" }))); };
var StyledFacebook32 = styled_components_1.default(Facebook32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledFacebook32;
var templateObject_1;
//# sourceMappingURL=Facebook32.js.map